document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".luxury-card");

  cards.forEach((card) => {

    card.addEventListener("mousemove", (e) => {

      const rect = card.getBoundingClientRect();

      const x = e.clientX - rect.left;

      const y = e.clientY - rect.top;

      const rotateX = ((y / rect.height) - .5) * -6;

      const rotateY = ((x / rect.width) - .5) * 6;

      card.style.transform =
      `perspective(1000px)
       rotateX(${rotateX}deg)
       rotateY(${rotateY}deg)
       translateY(-8px)`;

    });

    card.addEventListener("mouseleave", () => {

      card.style.transform =
      "perspective(1000px) rotateX(0) rotateY(0) translateY(0)";

    });

  });

});